import { useDeleteFolderModalMutation } from 'generated/graphql';
import React from 'react';


export function useDeleteFolder() {
  const [
    fnMutate,
    tuple
  ] = useDeleteFolderModalMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (id: string) => {
      await fnMutate({
        variables: {
          id
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
